import { create } from 'zustand';

import { createSidebarShellSlice } from './actions';
import { SidebarShellStore } from './types';

export const useSidebarShellStore = create<SidebarShellStore>()(
  (set, get, store) => ({
    ...createSidebarShellSlice(set, get, store),
  }),
);
